module.exports = __webpack_public_path__ + "img/body.ee4e6592.png";